import { render, staticRenderFns } from "./SearchCandidateResultTileWidget.vue?vue&type=template&id=cbabd4be&"
import script from "./SearchCandidateResultTileWidget.vue?vue&type=script&lang=js&"
export * from "./SearchCandidateResultTileWidget.vue?vue&type=script&lang=js&"
import style0 from "./SearchCandidateResultTileWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VHover,VIcon,VRow})
